import { createContext } from "react";


/**
 * Create the context
 */
const AlertContext = createContext({
    showAlert: true,
    text: undefined,
    color: '',
    setShowAlert: () => {/* */},
    setColor: () => {/* */},
    setText: () => {/* */},
    toggleAlert: () => {/* */}
});

export default AlertContext;
